// eslint-disable-next-line import/no-named-as-default
import gql from 'graphql-tag';

/**
 * The minimal set of information needed to
 * display a photo in the photos list.
 */
const photoLight = gql`
  fragment photoLight on GGPhoto {
    id: uid
    gqlid: id
    title
    takenOn
    createdAt
    thumbnailUrl
    formsCount
    markupsCount
    issuesCount
    rfisCount
    assetsCount
    submittalsCount
    imageType
  }
`;

/**
 * The minimal set of information needed to
 * display a photo in the details view
 */
const photoDetailed = gql`
  fragment photoDetailed on GGPhoto {
    ...photoLight
    fullUrl
    fileUrl
    location {
      lat
      lng
    }
    takenBy: creator {
      id
      firstName
      lastName
      email
      status
    }
    tags: photoTags(excludeAutotags: $excludeAutotags) {
      name
      type
    }
    isLocked
    locationId
  }
  ${photoLight}
`;

export const GET_PHOTOS = gql`
  query getPhotos(
    $projectId: String!
    $title: String
    $limit: Int
    $lastCursor: String
    $uids: [String!]
    $createdBefore: DateTime
    $createdAfter: DateTime
    $beforeTakenOn: DateTime
    $afterTakenOn: DateTime
    $imageTypes: [String!]
    $creatorIds: [String!]
    $referencedBy: [Referencer!]
    $tags: [String!]
    $matchAllTags: Boolean
    $excludeAutotags: Boolean
    $locationIds: [String!]
    $includeSubLocations: Boolean
    $usePermissionsEndPoint: Boolean = true
  ) {
    ggProjectByUid(uid: $projectId) {
      id
      photos(
        first: $limit
        title: $title
        after: $lastCursor
        photoUids: $uids
        anyType: true
        createdBefore: $createdBefore
        createdAfter: $createdAfter
        beforeTakenOn: $beforeTakenOn
        afterTakenOn: $afterTakenOn
        imageTypes: $imageTypes
        creatorIds: $creatorIds
        referencedBy: $referencedBy
        tags: $tags
        matchAllTags: $matchAllTags
        excludeAutotags: $excludeAutotags
        locationIds: $locationIds
        includeSubLocations: $includeSubLocations
        usePermissionsEndPoint: $usePermissionsEndPoint
      ) {
        edges {
          cursor
          node {
            ...photoLight
          }
        }
        pageInfo {
          hasNextPage
        }
      }
    }
  }
  ${photoLight}
`;

export const GET_PHOTO_DETAIL = gql`
  query getPhotoDetail(
    $projectId: String!
    $photoUid: String!
    $excludeAutotags: Boolean
  ) {
    ggPhotoByUid(projectUid: $projectId, uid: $photoUid) {
      ...photoDetailed
    }
  }
  ${photoDetailed}
`;

export const CREATE_PHOTO_ASSET = gql`
  mutation createPhotoAsset($input: GGCreatePhotoAssetInput!) {
    ggCreatePhotoAsset(input: $input) {
      fields
      action
      method
      photoId
      photoUid
    }
  }
`;

export const UPDATE_PHOTO = gql`
  mutation updatePhoto($input: GGUpdatePhotoInput!, $excludeAutotags: Boolean) {
    ggUpdatePhoto(input: $input) {
      photo {
        ...photoDetailed
      }
    }
  }
  ${photoDetailed}
`;

export const UPDATE_PHOTO_TITLE = gql`
  mutation updatePhotoTitle($input: GGUpdatePhotoInput!) {
    ggUpdatePhoto(input: $input) {
      photo {
        id: uid
        title
        gqlid: id
      }
    }
  }
`;

export const ADD_PHOTO_TAGS = gql`
  mutation addTagsToPhoto($input: GGAddTagsToPhotoInput!) {
    ggAddTagsToPhoto(input: $input) {
      photoUid
    }
  }
`;

export const REMOVE_PHOTO_TAGS = gql`
  mutation removeTagsFromPhoto($input: GGRemoveTagsFromPhotoInput!) {
    ggRemoveTagsFromPhoto(input: $input) {
      photoUid
    }
  }
`;

export const GET_TAGS = gql`
  query getTags($projectId: String!, $types: [TagType!]) {
    ggProjectByUid(uid: $projectId) {
      id
      tags: photoTags(types: $types) {
        name
        type
      }
    }
  }
`;

export const GET_SETTINGS = gql`
  query getProjectPhotoSettings($projectId: String!) {
    ggPhotoSettingsByProject(projectUid: $projectId) {
      items {
        name
        activated
      }
    }
  }
`;
